import { NETWORK } from '@arianee/arianeejs';
import moment from 'moment';

import { mergeNotificationsByTokenId } from '../helpers/merge-notifications';
import { EnrichedNotificationNetwork } from '../models/enriched-notification-network.model';

export interface NotificationItem {
	imageUrl: any;
	title: string;
	description: string;
	timestamp: string;
	unreadMessagesCount: number;
	network?: NETWORK;
	isRead: boolean;
	id: string;
}

export interface NotificationGroup {
	tokenId: string;
	items: NotificationItem[];
}

export function notificationsMapper(
	items: EnrichedNotificationNetwork[],
): NotificationGroup[] {
	const notificationGroups = mergeNotificationsByTokenId(items);
	return notificationGroups
		.map(({ tokenId, items }) => {
			const unreadMessagesCount = items.filter((item) => !item.isRead).length;
			const mappedItems: NotificationItem[] = items
				.map((item) => ({
					imageUrl: item.image,
					title: item.productName,
					description: item.title || item.message,
					timestamp: item.time,
					network: item.network,
					isRead: item.isRead,
					id: item.id,
					unreadMessagesCount,
				}))
				.sort(
					(a, b) =>
						moment(b.timestamp).valueOf() - moment(a.timestamp).valueOf(),
				);
			return { tokenId, items: mappedItems };
		})
		.sort((a, b) => {
			const aTimestamp = moment(a.items[0].timestamp).valueOf();
			const bTimestamp = moment(b.items[0].timestamp).valueOf();
			return bTimestamp - aTimestamp;
		});
}
